export const CONTACT_FORM_IFRAME_URL =
  "https://crm.zoho.in/crm/WebFormServeServlet?rid=9bc54816d35e3b89b3f4e3174011ea7e71b0174774df4ed317a173b7987205992ae6f2064307e1e2c40b78eab2fda59fgidc1443d9f8b79663fbb5945dd0ef43ae1630205bfba498bb416596682ae71e36c";
